// Label the actual visible gallery sequence after native filtering and custom slot insertion.
if (!customElements.get('df-gallery-labels')) {
  customElements.define('df-gallery-labels', class extends HTMLElement {
    connectedCallback() {
      this.gallery = this.closest('product-gallery');
      if (!this.gallery) return;
      this.observer = new MutationObserver(() => this.schedule());
      this.observer.observe(this.gallery, { subtree: true, childList: true, attributes: true, attributeFilter: ['hidden'] });
      this.schedule();
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      cancelAnimationFrame(this.frame);
      this.frame = null;
    }
    schedule() {
      if (this.frame != null) return;
      this.frame = requestAnimationFrame(() => {
        this.frame = null;
        this.updateLabels();
      });
    }
    updateLabels() {
      const cells = [...this.gallery.querySelectorAll('.product-gallery__carousel > .product-gallery__media')].filter(cell => !cell.hidden);
      const positions = new Map(cells.map((cell, index) => [cell.dataset.mediaId, index + 1]));
      const label = (template, index) => template.replace('__index__', index).replace('__count__', cells.length);
      const setLabel = (element, value) => {
        if (element.getAttribute('aria-label') !== value) element.setAttribute('aria-label', value);
      };
      cells.forEach((cell, index) => setLabel(cell, label(this.dataset.itemLabel, index + 1)));
      for (const selector of ['product-gallery-navigation > .product-gallery__thumbnail', 'carousel-navigation > button']) {
        const controls = [...this.gallery.querySelectorAll(selector)].filter(control => !control.hidden);
        controls.forEach((control, index) => {
          const position = positions.get(control.dataset.mediaId || control.id) || index + 1;
          const text = label(this.dataset.goLabel, position);
          setLabel(control, text);
          const hiddenText = control.querySelector('.sr-only');
          if (hiddenText && hiddenText.textContent !== text) hiddenText.textContent = text;
        });
      }
    }
  });
}
